"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _MediaPlayPauseButton = _interopRequireDefault(require("./MediaPlayPauseButton"));

var _MediaVolumeControls = _interopRequireDefault(require("./MediaVolumeControls"));

var _MediaTimeControls = _interopRequireDefault(require("./MediaTimeControls"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    width: "100%",
    zindex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: "black",
    color: "white"
  },
  header: {
    display: "flex",
    width: "100%",
    alignItems: "center"
  },
  footer: {
    margin: theme.spacing(0, 1)
  },
  playPauseButton: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    margin: theme.spacing(1),
    "&:hover": {
      backgroundColor: theme.palette.primary.dark
    }
  },
  info: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(0, 1)
  },
  title: {
    fontFamily: "Akkurat, sans-serif",
    fontWeight: "bold",
    color: "white"
  },
  description: {
    fontFamily: "Akkurat, sans-serif",
    color: "rgba(255, 255, 255, 0.7)"
  }
}));

const VideoControls = ({
  className,
  title,
  untitled,
  description,
  paused,
  buffered,
  duration = 0,
  currentTime = 0,
  onPlayPause,
  onSeek,
  muted,
  volume,
  onMute,
  onVolume
}) => {
  const classes = useStyles();
  return _react.default.createElement("nav", {
    className: className || classes.root
  }, _react.default.createElement("header", {
    className: classes.header
  }, _react.default.createElement(_MediaPlayPauseButton.default, {
    className: classes.playPauseButton,
    paused: paused,
    onClick: onPlayPause
  }), _react.default.createElement("div", {
    className: classes.info
  }, _react.default.createElement(_Typography.default, {
    component: "h2",
    className: classes.title
  }, title || untitled), description && _react.default.createElement(_Typography.default, {
    component: "h3",
    className: classes.description
  }, description))), _react.default.createElement("footer", {
    className: classes.footer
  }, _react.default.createElement(_MediaTimeControls.default, {
    duration: duration,
    currentTime: currentTime,
    onChange: onSeek
  })));
};

var _default = VideoControls;
exports.default = _default;
module.exports = exports.default;